import "../styles/home.css";

import Hero from "../components/hero";
import About from "./about";
import Services from "./services";
import Why from "../components/why";
import Models from "../components/models";
import Products from "./products";
import Cta from "../components/cta";
import Testimonials from "../components/testimonials";

function Home() {
    return (
        <>
            <Hero />
            <About />
            <Services />
            <section id="why-us">
                <Why />
            </section>
            <section id="models">
                <Models />
            </section>
            <Products />
            <Cta />
            <Testimonials />
        </>
    );
}

export default Home;